/**
 * Copyright Highway9 Networks Inc.
 */

import { ChatMemory } from "~/types/chatMemory";
import APIService from "./APIServices"; 

const memoryAPI = new APIService<ChatMemory>("memory");


const memoryService = {
  fetchMemories: memoryAPI.getAll,
  createMemory: memoryAPI.create,
  updateMemory: memoryAPI.update,
  deleteMemory: memoryAPI.delete,
};

export default memoryService;